import 'swiper/css/bundle';
import Swiper from 'swiper';

import './private-labels.scss';


const pivateLabels = () => {
    let args = {
        slidesPerView: 5,
        spaceBetween: 0,
        centeredSlides: false,
        breakpoints: {
            // when window width is >= 200px
            200: {
              slidesPerView: 1.8,
              centeredSlides: true,
            },
            768: {
              slidesPerView: 3.5,
              centeredSlides: true,
            },
            992: {
                slidesPerView: 5,
                centeredSlides: false,
            }
          }
        
    };
    let labelsSwiper = new Swiper(document.querySelector('.labelSwiper'), args);
}


export default pivateLabels;


